<template>
    <div v-if="customer">
        <v-toolbar flat color="brown" dark extended>
            <v-toolbar-title>{{customer.company}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-progress-linear
                    :active="updating || $apollo.loading"
                    :indeterminate="updating || $apollo.loading"
                    absolute
                    top
                    height="5"
                    background-color="blue"
                    color="red accent-4"
            ></v-progress-linear>

            <template v-slot:extension>

                <v-tabs
                        v-model="tab"
                        align-with-title
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#overview">
                        Overview
                    </v-tab>
                    <v-tab href="#bookings">

                        <v-badge
                                color="green"
                                :content="customer.bookings.length"
                        >
                            Bookings
                        </v-badge>

                    </v-tab>
                </v-tabs>
            </template>
        </v-toolbar>
        <v-container fluid>
            <v-tabs-items :value="tab">
                <v-tab-item value="overview">
                    <v-toolbar flat light color="grey lighten-4">
                        <v-spacer/>

                        <v-btn color="light-green" class="mr-2" dark @click="updateCustomer">Save</v-btn>
                    </v-toolbar>
                    <v-container fluid>
                        <CustomerForm
                            ref="form"
                            :customer="customer"
                        />
                    </v-container>
                </v-tab-item>
                <v-tab-item value="bookings">
                    <v-card>
                        <v-card-title></v-card-title>

                        <v-card-text>

                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                    <tr>
                                        <th class="text-left">ID</th>
                                        <th class="text-left">Date</th>
                                        <th class="text-left">Company</th>
                                        <th class="text-left">Title</th>
                                        <th class="text-left">Booker</th>
                                        <th class="text-left">Rep</th>
                                        <th class="text-left">Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="booking in customer.bookings" :key="booking.id">
                                        <td>
                                            <v-btn :to="{name:'booking-view', params: {id: booking.id}}" small>BK-{{ booking.id }}</v-btn>
                                        </td>
                                        <td>{{ booking.bookingDate | formatDate('ddd, D MMM YY') }}</td>
                                        <td>{{ booking.contactCompany }}</td>
                                        <td>{{ booking.courseTitle }}</td>
                                        <td>{{ booking.contactName }}</td>
                                        <td></td>
                                        <td>{{ booking.totalPrice }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>


        </v-container>
    </div>
</template>

<script>
    import CUSTOMER_GET from "../graphql/Customer/Get.gql";
    import Dashboard from "../layouts/Dashboard";
    import CustomerForm from "../components/Customer/CustomerForm";
    import CUSTOMER_UPDATE from "../graphql/Customer/Update.gql";

    export default {
        components: {
            CustomerForm
        },
        metaInfo() {
            return {
                title: this.title
            }
        },
        created() {
            this.$emit('update:layout', Dashboard);
        },
        apollo: {
            customer: {
                query: CUSTOMER_GET,
                variables() {
                    return {
                        id: parseInt(this.$route.params.id)
                    }
                },
                update: data => data.customer
            },
        },
        data() {
            return {
                title: 'Customer ' + this.$route.params.id,
                tab: null,
                updating: false,
            }
        },
        watch: {
            customer(value) {
                this.title = value.company
            }
        },
        methods: {
            updateCustomer() {
                this.$refs.form.validate()

                if(!this.$refs.form.isValid()){
                    return
                }

                let customer = JSON.parse(JSON.stringify(this.customer))

                delete customer.__typename
                delete customer.bookings

                this.$apollo.mutate({
                    mutation: CUSTOMER_UPDATE,
                    variables: {input: customer},
                }).then((response) => {
                    this.$emit('complete')
                    this.updating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Customer updated successful')
                    this.$router.push({ name: 'customer-view', params: { id: response.data.createCustomer.id } })
                }).catch((error) => {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        },
    }
</script>

<style scoped>

</style>